<template>
<div class='contBox points pointsDetail'>
    <div :class="ifOpenNew == 1 ? 'pointsBox' : 'pointsBox Mt102'">
        <v-head ref="vhead"></v-head>
        <div class="contentBox">
            <div class='pointsDetailBanner'>
                <h2 class='bt'>Points Store</h2>
                <p class="st">Redeeming Space Points for Prize: Planet NFT, xSPACE, Airdrop, WL, etc.</p>
            </div>
        </div>
    </div>
    <div class='contentBox '>
        <div class="redeemBox">
            <h4>First Points Redemption Event<span>Your Points: {{numToflxed3(userPoints)}}</span></h4>
            <p class="redeemP1">5000 Points - 1 NFT Planet (limited to 3 copies,  max 1 redemption per address).</p>
            <p class="redeemP1">300 Points - 50xSPACE (limited to 100 copies, max 3 redemptions per address).</p>
            <ul>
                <li>
                    <div class="liImg">
                        <img src="../../images/points/nftRedeem.png" alt="" srcset="">
                        <p class="tipNum">{{ 3-Number(remeednftInfo.num) }}/3 SOLD</p>
                    </div>
                    <div class="liT">
                        <p class="test"><span>Planet NFT</span> <span>redeemed: {{userAddress ? 1-Number(usernftLimit) : 0}}</span></p>
                        <div class="pointsNum">
                            <p>{{remeednftPoints}} Points</p>
                            <div>
                                <p class="handleUnlock" @click='minusbtn("nft")'><i class="el-icon-minus"></i></p>
                                <p class="num">{{redeemnftNum}}</p>
                                <p class="handleUnlock" @click='plusBtn("nft")'><i class="el-icon-plus"></i></p>
                            </div>
                        </div>
                        <div class="btn">
                            <div v-if="usernftLimit == 0 || userPoints < remeednftPoints || remeednftInfo.num == 0" @click="noredeem('nft')" style="background:#b2b2b2;">Redeem</div>
                            <div v-else @click="Redeem('nft')">Redeem <i v-if="redeemnftLoading" class="el-icon-loading"></i></div>
                            <p>max 1 redemption per address</p>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="liImg">
                        <img src="../../images/points/xspaceRedeem.png" alt="" srcset="">
                        <p class="tipNum">{{ 100-Number(remeedxSPACEInfo.num) }}/100 SOLD</p>
                    </div>
                    <div class="liT">
                        <p class="test"><span>50 xSPACE</span> <span>redeemed: {{userAddress ? 3-Number(userxspaceLimit) : 0}}</span></p>
                        <div class="pointsNum">
                            <p>{{remeedxSPACEPoints * redeemXspaceNum}} Points</p>
                            <div>
                                <p class="handleUnlock" @click='minusbtn("xspace")'><i class="el-icon-minus"></i></p>
                                <p class="num">{{redeemXspaceNum}}</p>
                                <p class="handleUnlock" @click='plusBtn("xspace")'><i class="el-icon-plus"></i></p>
                            </div>
                        </div>
                        <div class="btn">
                            <div v-if="userxspaceLimit == 0 || userPoints < remeedxSPACEPoints * redeemXspaceNum || remeedxSPACEInfo.num == 0" @click="noredeem('xspace')" style="background:#b2b2b2;">Redeem</div>
                            <div v-else @click="Redeem('xspace')">Redeem <i v-if="redeemxspaceLoading" class="el-icon-loading"></i></div>
                            <p>max 3 redemptions per address</p>
                        </div>
                    </div>
                </li>
                <li style="background: none;box-shadow: none;"></li>
            </ul>
        </div>
    </div>
    <v-footer></v-footer>
</div>
</template>

<script> 
import Web3 from 'web3'; 
import { judgeNetwork, pointConvert, getUserFinish, getUserPoint, getPrize, getUserLimit } from '../../spaceevmostest.js'
    export default {
        data() {
            return {
                userAddress:'',
                ifOpenNew:1,
                userPoints:0,usernftLimit:0,userxspaceLimit:0,
                redeemnftLoading:false,redeemxspaceLoading:false,
                remeednftInfo:[],remeedxSPACEInfo:[],
                remeednftPoints:0,remeedxSPACEPoints:0,
                redeemnftNum:1,
                redeemXspaceNum:1,
            }
        },
        computed:{
            changeNumber() {
                return (val) => {
                    var number = val.toString().replace(/\d+/, function (n) {
                        return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
                            return $1 + ",";
                        });
                    })
                    return number;
                }
            },
            numToflxed3() {
                return ( num ) => {
                    if ( num == 0 ) {
                        return '0.000'
                    } else {
                        var num = num.toString().split('.')
                        if ( num[1] ) {
                            if ( num[1].length >= 3 ) {
                                return num[0] + '.' + num[1].slice(0, 3);
                            } else if ( num[1].length == 2) {
                                return num[0] + '.' + num[1].slice(0, num[1].length) + '0';
                            } else if ( num[1].length == 1) {
                                return num[0] + '.' + num[1].slice(0, num[1].length) + '00';
                            }
                        } else {
                            return num[0] + '.000'
                        }
                    }
                }
            }
        },
        mounted(){
            if(localStorage.getItem('chainId') != 324){
                this.$router.push({path:'/home'})
                return false
            }
            localStorage.setItem('0x339299',1)
            if ( this.$isMobile ) {
                this.ifOpenNew = 0
            } else {
                this.ifOpenNew = 1
            }
            this.userAddress = localStorage.getItem('userAddress')
            this.pointAddress = window.homeData.zkSyncMainnet.pointAddress
            this.getData()
        },
        methods: {
            Redeem(type){
                judgeNetwork().then(res => {
                    if (res == 0) {
                        return false
                    }
                    if(type == 'nft'){
                        if (this.redeemnftLoading) {
                            return false
                        }
                        this.redeemnftLoading = true
                        pointConvert(this.pointAddress,0,0,this.redeemnftNum,this.userAddress).then(res => {
                            this.redeemnftLoading = false
                            this.redeemnftNum = 1
                            this.getData()
                            this.$notify({ type: 'success', message: 'Redeem Successful' });
                            var data = {
                                address:this.userAddress,
                                points:this.remeednftPoints,
                            }
                            let s_data = this.sort_ascii(data)+'&key=SpaceBlockSign888888';
                            // console.log(data,s_data)
                            // return
                            let sign = this.$md5(s_data);
                            this.$ajax.ajax({
                                type: "POST",
                                url: "https://apiv2.spacefi.io/?method=points.points.updateuserpoints",
                                data: {
                                    sign:sign.toUpperCase(),
                                    address:this.userAddress,
                                    points:this.remeednftPoints,
                                },
                                xhrFields:{ withCredentials:true },
                                dataType: "json",
                                success: (data) => {
                                    // console.log(data)
                                }
                            })
                        }).catch(err => {
                            this.redeemnftLoading = false
                            this.$notify({ type: 'warning', message: 'Redeem Failed' });
                        })
                    }
                    if(type == 'xspace'){
                        if(Number(this.remeedxSPACEPoints * this.redeemXspaceNum) > Number(this.userPoints)){
                            this.$notify({ type: 'warning', message: 'Not enough points' });
                            return false
                        }
                        if (this.redeemxspaceLoading) {
                            return false
                        }
                        this.redeemxspaceLoading = true
                        pointConvert(this.pointAddress,0,1,this.redeemXspaceNum,this.userAddress).then(res => {
                            this.redeemxspaceLoading = false
                            this.redeemXspaceNum = 1
                            this.getData()
                            this.$notify({ type: 'success', message: 'Redeem Successful' });
                            var data = {
                                address:this.userAddress,
                                points:this.remeedxSPACEPoints * this.redeemXspaceNum,
                            }
                            let s_data = this.sort_ascii(data)+'&key=SpaceBlockSign888888';
                            // console.log(data,s_data)
                            // return
                            let sign = this.$md5(s_data);
                            this.$ajax.ajax({
                                type: "POST",
                                url: "https://apiv2.spacefi.io/?method=points.points.updateuserpoints",
                                data: {
                                    sign:sign.toUpperCase(),
                                    address:this.userAddress,
                                    points:this.remeedxSPACEPoints * this.redeemXspaceNum,
                                },
                                xhrFields:{ withCredentials:true },
                                dataType: "json",
                                success: (data) => {
                                    // console.log(data)
                                }
                            })
                        }).catch(err => {
                            this.redeemxspaceLoading = false
                            this.$notify({ type: 'warning', message: 'Redeem Failed' });
                        })
                    }
                })
            },
            noredeem(type){
                if(type == 'nft'){
                    if(this.usernftLimit == 0){
                        this.$notify({ type: 'warning', message: 'max 1 redemption per address' });
                    }else {
                        if(Number(this.remeednftPoints) > Number(this.userPoints)){
                            this.$notify({ type: 'warning', message: 'Not enough points' });
                            return false
                        }
                        if(Number(this.remeednftInfo.num) == 0){
                            this.$notify({ type: 'warning', message: 'Redemption sold out' });
                            return false
                        }
                    }
                }
                if(type == 'xspace'){
                    if(Number(this.remeedxSPACEPoints * this.redeemXspaceNum) > Number(this.userPoints)){
                        this.$notify({ type: 'warning', message: 'Not enough points' });
                        return false
                    }
                    if(Number(this.remeedxSPACEInfo.num) == 0){
                        this.$notify({ type: 'warning', message: 'Redemption sold out' });
                        return false
                    }
                    this.$notify({ type: 'warning', message: 'max 3 redemptions per address' });
                }
            },
            minusbtn(type){
                if(type == 'nft'){
                    if (Number(this.remeednftInfo.num) == 0) {
                        this.$notify({ type: 'warning', message: 'Redemption sold out' });
                        return false
                    }
                    this.$notify({ type: 'warning', message: 'Redeem cannot be less than 1' });
                } else {
                    if (this.userxspaceLimit == 0) {
                        this.$notify({ type: 'warning', message: 'Redeem cannot be less than 1' });
                        return false
                    }
                    if (this.redeemXspaceNum == 1) {
                        this.$notify({ type: 'warning', message: 'Redeem cannot be less than 1' });
                    } else {
                        this.redeemXspaceNum = this.redeemXspaceNum-1
                    }
                }
            },
            plusBtn(type){
                if(type == 'nft'){
                    if(Number(this.remeednftPoints) > Number(this.userPoints)){
                        this.$notify({ type: 'warning', message: 'Not enough points' });
                        return false
                    }
                    if (Number(this.remeednftInfo.num) == 0) {
                        this.$notify({ type: 'warning', message: 'Redemption sold out' });
                        return false
                    }
                    this.$notify({ type: 'warning', message: 'max 1 redemption per address' });
                } else {
                    if(Number(this.remeedxSPACEPoints * this.redeemXspaceNum) > Number(this.userPoints)){
                        this.$notify({ type: 'warning', message: 'Not enough points' });
                        return false
                    }
                    if (this.userxspaceLimit == 0) {
                        this.$notify({ type: 'warning', message: 'max 3 redemptions per address' });
                        return false
                    }
                    if (this.redeemXspaceNum >= Number(this.remeedxSPACEInfo.num)) {
                        this.$notify({ type: 'warning', message: 'Insufficient share of redemption' });
                        return false
                    }
                    if(this.redeemXspaceNum != this.userxspaceLimit){
                        this.redeemXspaceNum = this.redeemXspaceNum+1
                    }  else if (this.redeemXspaceNum == this.userxspaceLimit) {
                        this.$notify({ type: 'warning', message: 'max 3 redemptions per address' });
                    } else if (this.redeemXspaceNum == 1) {
                        this.$notify({ type: 'warning', message: 'max 1 redemption per address' });
                    }
                }
            },
            getData(){
                if (this.userAddress) {
                    getUserFinish(this.pointAddress,0,this.userAddress).then(res => {
                        if (!res) {
                            this.$ajax.ajax({
                                type: "POST",
                                url: "https://apiv2.spacefi.io/?method=points.points.getuserpoints",
                                data: {
                                    user:this.userAddress,
                                },
                                xhrFields:{ withCredentials:true },
                                dataType: "json",
                                success: (data) => {
                                    this.userPoints = data.data.data.total_points == null ? 0 : Number(data.data.data.total_points)
                                }
                            })
                        } else {
                            getUserPoint(this.pointAddress,0,this.userAddress).then(res => {
                                this.userPoints = Number(res/1e18)
                            })
                        }
                    })
                    getUserLimit(this.pointAddress,0,0,this.userAddress).then(res => {
                        this.usernftLimit = res
                    })
                    getUserLimit(this.pointAddress,0,1,this.userAddress).then(res => {
                        this.userxspaceLimit = res
                    })
                }
                getPrize(this.pointAddress,0,0).then(res => {
                    this.remeednftInfo = res
                    this.remeednftPoints = Number(res.point/1e18)
                })
                getPrize(this.pointAddress,0,1).then(res => {
                    this.remeedxSPACEInfo = res
                    this.remeedxSPACEPoints = Number(res.point/1e18)
                })
            },
            sort_ascii(obj) {
                let arr = new Array();
                let num = 0;
                for (let i in obj) {
                    arr[num] = i;
                    num++;
                }
                let sortArr = arr.sort();
                //let sortObj = {};    
                let str = '';       
                for (let i in sortArr) {
                    str += sortArr[i] + '=' + obj[sortArr[i]] + '&';
                    //sortObj[sortArr[i]] = obj[sortArr[i]];
                }
                let char = '&'
                str = str.replace(new RegExp('^\\' + char + '+|\\' + char + '+$', 'g'), '');

                return str;
                //return sortObj;
            },
        },
    }
</script> 